import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router} from '@angular/router';
import { FormsModule } from '@angular/forms';

import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { MultiSelectModule } from 'primeng/multiselect';
import { DatePickerModule } from 'primeng/datepicker';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

import { emptyOrderAdminKpis, OrderAdminKpisDto, OrderAdminQuery, OrderService } from '../../../core/services/order.service';
import {
  PackingPrintService,
  PackingPerPage,
  PackingPrintFilter,
  PACKING_PER_PAGE_OPTIONS,
  PACKING_STATUS_OPTIONS,
  guiaImpresaQuery
} from '../../../core/services/packing-print.service';
import { EstadosService } from '../../../core/services/estados.service';
import { TipoEnvioService } from '../../../core/services/tipo-envio.service';
import { OrigenVentaService } from '../../../core/services/origen-venta.service';
import { Order } from '../../../shared/models/Order';
import { PeruDatePipe } from '../../../shared/pipes/peru-date.pipe';
import { formatMoananiDateTimeExport, ymdFromLocalDate } from '../../../core/utils/peru-datetime';
import {
  AdminExportBundle,
  boletaMapFromOrders,
  boletaStatusFromOrder,
  isTerminalOrderStatus,
  loadAdminExport,
  mergeOrderRow,
  orderIdsWithoutBoletaFlag
} from '../../../core/utils/admin-order-page';
import { Estado } from '../../../shared/models/system';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { exportJsonToExcel } from '../../../core/utils/excel-export';
import { BoletaService, OrderBoletaStatus } from '../../../core/services/boleta.service';
import {
  getBoletaExportLabel,
  getOrderAmountPaid,
  getOrderDeliveryPrice,
  getOrderProductLabel,
  getOrderTotalAmount,
  money
} from '../../../core/utils/order-export';

@Component({
  selector: 'app-orders-list',
  standalone: true,
  imports: [
    CommonModule, TableModule, ButtonModule, InputTextModule,
    TagModule, TooltipModule, IconFieldModule, InputIconModule,
    DialogModule, SelectModule, MultiSelectModule, FormsModule, ToastModule, DatePickerModule,
    PeruDatePipe,
  ],
  providers: [MessageService],
  templateUrl: './orders-list.component.html',
  styleUrls: ['./orders-list.component.css']
})
export class OrdersListComponent implements OnInit {


  deliveryOrders: Order[] = [];
  pickupOrders: Order[] = [];
  pageOrders: Order[] = [];
  filteredOrders: Order[] = [];
  first = 0;
  rows = 10;
  totalRecords = 0;
  tipoEnvioFilterId: number | null = null;
  tipoEnvioFilterOptions: { label: string; value: number | null }[] = [{ label: 'Todos los envíos', value: null }];
  origenVentaFilterId: number | null = null;
  origenVentaFilterOptions: { label: string; value: number | null }[] = [{ label: 'Todos los orígenes', value: null }];
  private searchTimer: ReturnType<typeof setTimeout> | null = null;
  estadoFilterIds: number[] = [];
  fechaRegistroFilter: Date | null = null;
  fechaEntregaFilter: Date | null = null;
  clienteFilter: string = '';
  idSearch: string = '';
  packingPerPage: PackingPerPage = 1;
  packingPrintFilter: PackingPrintFilter = '';
  packingPerPageOptions = PACKING_PER_PAGE_OPTIONS;
  packingStatusOptions = PACKING_STATUS_OPTIONS;

  selectedOrders: Order[] = [];
  isBulkStatus: boolean = false;

  loading: boolean = true;
  exporting: 'excel' | 'pdf' | null = null;
  private kpis: OrderAdminKpisDto = emptyOrderAdminKpis();
  private kpiRequest = 0;
  private listRequest = 0;

  statusDialogVisible: boolean = false;
  selectedOrderForStatus: Order | null = null;
  selectedEstadoIds: number[] = [];
  estadoOptions: Estado[] = [];

  viewDialogVisible: boolean = false;
  selectedOrderForView: Order | null = null;
  boletaStatusMap: Record<number, OrderBoletaStatus> = {};

  constructor(
    private orderService: OrderService,
    private packingPrint: PackingPrintService,
    private estadosService: EstadosService,
    private tipoEnvioService: TipoEnvioService,
    private origenVentaService: OrigenVentaService,
    private boletaService: BoletaService,
    private cd: ChangeDetectorRef,
    private messageService: MessageService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadKpis();
    this.estadosService.getActive().subscribe({
      next: (list) => { this.estadoOptions = list; this.cd.detectChanges(); },
      error: () => {}
    });
    this.tipoEnvioService.getActive().subscribe({
      next: (list) => {
        this.tipoEnvioFilterOptions = [
          { label: 'Todos los envíos', value: null },
          ...list.map(t => ({ label: t.nombreTipoEnvio, value: t.id }))
        ];
        this.cd.detectChanges();
      },
      error: () => {}
    });
    this.origenVentaService.getAll().subscribe({
      next: (list) => {
        this.origenVentaFilterOptions = [
          { label: 'Todos los orígenes', value: null },
          ...list.map(o => ({ label: o.nombreOrigenVenta, value: o.id }))
        ];
        this.cd.detectChanges();
      },
      error: () => {}
    });
  }

  scheduleServerLoad(): void {
    if (this.searchTimer) clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => this.reloadFirst(), 350);
  }

  onFechaRegistroChange(): void {
    this.reloadFirst();
  }

  reloadFirst(): void {
    this.first = 0;
    this.loadKpis();
    this.loadOrders({ first: 0, rows: this.rows });
  }

  get totalAdelantado(): number {
    return this.kpis.totalAdelantado;
  }

  get totalEnvioInformativo(): number {
    return this.kpis.totalEnvioAdelantado;
  }

  get totalVentas(): number {
    return this.kpis.totalVentas;
  }

  get totalPagoPendiente(): number {
    return this.kpis.totalPagoPendiente;
  }

  private buildFromTo(): { from?: string; to?: string } {
    if (!this.fechaRegistroFilter) return {};
    const day = ymdFromLocalDate(this.fechaRegistroFilter);
    return { from: day, to: day };
  }

  private orderIdParam(): number | undefined {
    const raw = (this.idSearch || '').trim();
    if (!/^\d+$/.test(raw)) return undefined;
    const id = Number(raw);
    return Number.isSafeInteger(id) && id > 0 ? id : undefined;
  }

  private listFilters(): OrderAdminQuery | null {
    const rawId = (this.idSearch || '').trim();
    if (rawId && this.orderIdParam() == null) return null;
    return {
      canal: 'MANUAL',
      isManualSale: true,
      vista: 'ACTIVOS',
      q: this.clienteFilter?.trim() || undefined,
      orderId: this.orderIdParam(),
      tipoEnvioId: this.tipoEnvioFilterId ?? undefined,
      origenVentaId: this.origenVentaFilterId ?? undefined,
      estadoIds: this.estadoFilterIds?.length ? [...this.estadoFilterIds] : undefined,
      scheduledDate: this.fechaEntregaFilter ? ymdFromLocalDate(this.fechaEntregaFilter) : undefined,
      guiaImpresa: guiaImpresaQuery(this.packingPrintFilter),
      ...this.buildFromTo()
    };
  }

  loadKpis(): void {
    const filters = this.listFilters();
    if (!filters) {
      ++this.kpiRequest;
      this.kpis = emptyOrderAdminKpis();
      this.cd.detectChanges();
      return;
    }
    const request = ++this.kpiRequest;
    this.orderService.getAdminKpis(filters).subscribe({
      next: (kpis) => {
        if (request !== this.kpiRequest) return;
        this.kpis = kpis;
        this.cd.detectChanges();
      },
      error: () => {
        if (request !== this.kpiRequest) return;
        this.kpis = emptyOrderAdminKpis();
        this.cd.detectChanges();
      }
    });
  }

  loadOrders(event?: TableLazyLoadEvent) {
    const filters = this.listFilters();
    if (!filters) {
      ++this.listRequest;
      this.loading = false;
      this.pageOrders = [];
      this.filteredOrders = [];
      this.totalRecords = 0;
      this.cd.detectChanges();
      return;
    }
    const request = ++this.listRequest;
    this.loading = true;
    const first = event?.first ?? this.first;
    const rows = event?.rows || this.rows;
    this.first = first || 0;
    this.rows = rows;
    const page = this.rows > 0 ? Math.floor(this.first / this.rows) : 0;
    this.orderService.getAdminOrders({
      ...filters,
      page,
      size: this.rows
    }).subscribe({
      next: (res) => {
        if (request !== this.listRequest) return;
        this.pageOrders = res.content || [];
        this.filteredOrders = this.pageOrders;
        this.totalRecords = res.totalElements || 0;
        this.loading = false;
        this.syncBoletas(this.pageOrders);
        this.cd.detectChanges();
      },
      error: () => {
        if (request !== this.listRequest) return;
        this.loading = false;
        this.pageOrders = [];
        this.filteredOrders = [];
        this.totalRecords = 0;
        this.messageService.add({severity:'error', summary:'Error', detail:'Error al cargar pedidos'});
        this.cd.detectChanges();
      }
    });
  }

  private syncBoletas(orders: Order[]): void {
    this.boletaStatusMap = boletaMapFromOrders(orders);
    const missing = orderIdsWithoutBoletaFlag(orders);
    this.cd.detectChanges();
    if (!missing.length) return;
    this.boletaService.estadosOrdenes(missing).subscribe({
      next: (rows) => {
        rows.forEach(r => { this.boletaStatusMap[r.orderId] = r; });
        this.cd.detectChanges();
      },
      error: () => {}
    });
  }

  private applyUpdated(updated: Order): void {
    const drop = isTerminalOrderStatus(updated.status);
    const result = mergeOrderRow(this.pageOrders, updated, drop);
    this.pageOrders = result.rows;
    if (result.removed) this.totalRecords = Math.max(0, this.totalRecords - 1);
    this.selectedOrders = drop
      ? this.selectedOrders.filter(order => order.id !== updated.id)
      : this.selectedOrders.map(order => order.id === updated.id ? { ...order, ...updated } : order);
    if (this.selectedOrderForView?.id === updated.id) {
      if (drop) {
        this.selectedOrderForView = null;
        this.viewDialogVisible = false;
      } else {
        this.selectedOrderForView = { ...this.selectedOrderForView, ...updated };
      }
    }
    const flag = boletaStatusFromOrder(updated);
    if (drop) delete this.boletaStatusMap[updated.id];
    else if (flag) this.boletaStatusMap[updated.id] = flag;
    this.filteredOrders = this.pageOrders;
    this.cd.detectChanges();
  }

  editOrder(id: number) {
    this.router.navigate(['/admin/orders/edit', id]);
  }

  openViewDialog(order: Order) {
    this.selectedOrderForView = order;
    this.viewDialogVisible = true;
  }

  copyToClipboard(text: string): void {
    if (!text?.trim()) return;
    navigator.clipboard.writeText(text.trim()).then(() => {
      this.messageService.add({ severity: 'success', summary: 'Copiado', detail: 'Texto copiado al portapapeles', life: 2000 });
    }).catch(() => {
      this.messageService.add({ severity: 'warn', summary: 'Error', detail: 'No se pudo copiar', life: 2000 });
    });
  }

  getFullAddress(order: Order): string {
    const distrito = order.distrito?.nombre || order.district || '';
    const address = order.deliveryAddress || '';
    return distrito && address ? `${address}, ${distrito}` : address || distrito;
  }

  printOne(order: Order): void {
    this.printPackingSlips([order]);
  }

  printSelected(): void {
    this.printPackingSlips(this.selectedOrders || []);
  }

  printLastThree(): void {
    this.printPackingSlips(this.filteredOrders.slice(0, 3));
  }

  private printPackingSlips(orders: Order[]): void {
    this.packingPrint.printAndMark(orders, this.packingPerPage).subscribe({
      next: (updated) => {
        this.applyGuiaPrinted(updated);
        this.messageService.add({
          severity: 'success',
          summary: 'Hoja de empaque',
          detail: `${updated.length} pedido(s) listos para meter en la caja.`
        });
      },
      error: (err) => {
        if (err?.code === 'EMPTY') {
          this.messageService.add({ severity: 'warn', summary: 'Impresión', detail: 'Selecciona al menos un pedido.' });
          return;
        }
        if (err?.code === 'POPUP') {
          this.messageService.add({
            severity: 'warn',
            summary: 'Ventana bloqueada',
            detail: 'Permite ventanas emergentes e inténtalo de nuevo. No se marcó como impresa.'
          });
          return;
        }
        this.messageService.add({
          severity: 'warn',
          summary: 'Impresión',
          detail: 'Se abrió la impresión, pero no se pudo guardar el estado. Vuelve a intentar.'
        });
      }
    });
  }

  private applyGuiaPrinted(updated: Order[]): void {
    const ids = new Set(updated.map(o => o.id));
    if (guiaImpresaQuery(this.packingPrintFilter) === false) {
      this.selectedOrders = this.selectedOrders.filter(o => !ids.has(o.id));
    } else {
      const stamp = (o: Order): Order => ids.has(o.id) ? { ...o, guiaImpresa: true } : o;
      this.selectedOrders = this.selectedOrders.map(stamp);
    }
    this.loadKpis();
    this.loadOrders({ first: this.first, rows: this.rows });
  }

  getEstadosNames(estados?: { id: number; nombreEstado: string }[]): string {
    return estados?.map(e => e.nombreEstado).join(', ') ?? '';
  }

  openStatusDialog(order: Order) {
    this.isBulkStatus = false;
    this.selectedOrderForStatus = order;
    this.selectedOrders = [];
    this.selectedEstadoIds = order.estados?.map(e => e.id) ?? [];
    this.statusDialogVisible = true;
  }

  openBulkStatusDialog() {
    if (!this.selectedOrders?.length) {
      this.messageService.add({severity:'warn', summary:'Selección', detail:'Selecciona al menos un pedido'});
      return;
    }
    this.isBulkStatus = true;
    this.selectedOrderForStatus = null;
    this.selectedEstadoIds = [];
    this.statusDialogVisible = true;
  }

  saveStatus() {
    if (this.selectedEstadoIds.length === 0) {
      this.messageService.add({severity:'warn', summary:'Selección', detail:'Elige al menos un estado'});
      return;
    }
    if (this.isBulkStatus && this.selectedOrders?.length) {
      let completed = 0;
      const total = this.selectedOrders.length;
      this.selectedOrders.forEach(order => {
        this.orderService.updateEstados(order.id, this.selectedEstadoIds).subscribe({
          next: (updated) => {
            this.applyUpdated(updated);
            completed++;
            if (completed === total) {
              this.loadKpis();
              this.loadOrders({ first: this.first, rows: this.rows });
              this.messageService.add({severity:'success', summary:'Actualizado', detail:`Estados actualizados en ${total} pedido(s)`});
              this.statusDialogVisible = false;
              this.isBulkStatus = false;
              this.selectedOrders = [];
              this.cd.detectChanges();
            }
          },
          error: () => {
            completed++;
            if (completed === total) {
              this.loadKpis();
              this.loadOrders({ first: this.first, rows: this.rows });
              this.messageService.add({severity:'error', summary:'Error', detail:'Algunos pedidos no se pudieron actualizar'});
              this.statusDialogVisible = false;
              this.isBulkStatus = false;
              this.cd.detectChanges();
            }
          }
        });
      });
    } else if (this.selectedOrderForStatus) {
      this.orderService.updateEstados(this.selectedOrderForStatus.id, this.selectedEstadoIds).subscribe({
        next: (updated) => {
          this.messageService.add({severity:'success', summary:'Actualizado', detail:'Estados actualizados'});
          this.statusDialogVisible = false;
          this.applyUpdated(updated);
          this.loadKpis();
          this.loadOrders({ first: this.first, rows: this.rows });
        },
        error: () => {
          this.messageService.add({severity:'error', summary:'Error', detail:'No se pudo actualizar los estados'});
        }
      });
    }
  }

  // Helpers
  getSeverity(status: string): "success" | "secondary" | "info" | "warn" | "danger" | "contrast" | undefined {
    switch (status) {
      case 'PAGADO_COMPLETO': return 'success';
      case 'PAGO_COMPLETO': return 'success';
      case 'ADELANTO': return 'warn';
      case 'ADELANTO_50': return 'warn';
      case 'PENDIENTE_PAGO': return 'danger';
      case 'EN_VERIFICACION': return 'info';
      case 'ENTREGADO': return 'success';
      case 'EN_RUTA': return 'info';
      case 'CONFIRMADO': return 'secondary';
      case 'CANCELADO': return 'danger';
      default: return 'secondary';
    }
  }

  formatPaymentStatus(status: string): string {
    return status ? status.replace(/_/g, ' ') : '';
  }

  getPaymentTagLabel(paymentStatus: string | undefined, order: any): string {
    const st = (paymentStatus || '').toUpperCase();
    const pendiente = this.getOrderPendientePagar(order);
    const pagado = this.getOrderAmountPaid(order);
    if (st === 'PAGO_COMPLETO' || st === 'PAGADO_COMPLETO') return 'Pago completo';
    if (pendiente <= 0 && pagado > 0) return 'Pago completo';
    if (st === 'EN_VERIFICACION') return 'En verificación';
    if (['ADELANTO', 'ADELANTO_50', 'PENDIENTE_PAGO'].includes(st)) return 'Pago pendiente';
    if (pendiente > 0) return 'Pago pendiente';
    return this.formatPaymentStatus(paymentStatus || '') || '—';
  }

  getPaymentTagSeverity(paymentStatus: string | undefined, order: any): "success" | "secondary" | "info" | "warn" | "danger" | "contrast" | undefined {
    const label = this.getPaymentTagLabel(paymentStatus, order);
    if (label === 'Pago completo') return 'success';
    if (label === 'En verificación') return 'info';
    return 'warn';
  }

  calculateItemsSubtotal(order: any): number {
    if (!order || !order.items) return 0;
    return order.items.reduce((acc: number, item: any) => {
      const price = item.unitPrice || item.product?.price || item.product?.productPrice || 0;
      const quantity = item.quantity || 0;

      const itemSubtotal = (item.subTotal && item.subTotal > 0) ? item.subTotal : (price * quantity);

      return acc + itemSubtotal;
    }, 0);
  }

  private safeMoney(v: unknown): number {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  }

  getOrderAmountPaid(order: any): number {
    return this.safeMoney(order?.amountPaid);
  }

  getOrderTotalAmount(order: any): number {
    return this.safeMoney(order?.totalAmount);
  }

  getOrderPendientePagar(order: any): number {
    return Math.max(0, this.getOrderTotalAmount(order) - this.getOrderAmountPaid(order));
  }

  private formatDateTimeExport(isoStr: string): string {
    return formatMoananiDateTimeExport(isoStr || '');
  }

  private formatDateOnlyExport(dateStr: string, timeStr?: string): string {
    if (!dateStr) return '';
    const part = dateStr.split('T')[0];
    const [y, m, d] = part.split('-');
    if (!y || !m || !d) return dateStr;
    const formatted = `${d.padStart(2, '0')}/${m.padStart(2, '0')}/${y}`;
    return timeStr ? `${formatted} ${timeStr}` : formatted;
  }

  exportExcel(): void {
    this.runExport('excel', ({ rows, kpis, boletas }) => {
      const exportData = rows.map(o => ({
        'Fecha registro': this.formatDateTimeExport(o.createdAt || ''),
        'N° Orden': o.id,
        'Fecha entrega': this.formatDateOnlyExport(o.scheduledDate || '', o.scheduledTime || undefined),
        Cliente: o.clientName,
        Producto: getOrderProductLabel(o),
        'Tipo de Envío': o.tipoEnvio?.nombreTipoEnvio || o.deliveryMethod || '',
        Destino: (o.distrito?.nombre || o.district || '') + (o.deliveryAddress ? ' - ' + o.deliveryAddress : ''),
        'Estado': this.getEstadosNames(o.estados) || o.status,
        'Envío': getOrderDeliveryPrice(o),
        Adelanto: getOrderAmountPaid(o),
        'Total venta': getOrderTotalAmount(o),
        Boleta: getBoletaExportLabel(o.id, boletas),
        Observación: (o as any).notes || ''
      }));
      exportData.push({} as any);
      exportData.push({
        Cliente: 'RESUMEN',
        'Envío': kpis.totalEnvioAdelantado,
        Adelanto: kpis.totalAdelantado,
        'Total venta': kpis.totalVentas,
        Boleta: 'Envío informativo; cobrado = suma de adelantos'
      } as any);
      return exportJsonToExcel(
        exportData,
        `ventas_manuales_activas_${new Date().getTime()}.xlsx`
      );
    });
  }

  exportPdf(): void {
    this.runExport('pdf', ({ rows, kpis, boletas }) => {
      const doc = new jsPDF({ orientation: 'landscape' });
      doc.setFontSize(16);
      doc.text('Reporte de Ventas Manuales Activas', 14, 20);
      doc.setFontSize(10);
      doc.text(`Generado: ${new Date().toLocaleDateString()}`, 14, 28);
      const head = [['N°', 'Cliente', 'Producto', 'Estado', 'Envío', 'Adelanto', 'Total venta', 'Boleta']];
      const body = rows.map(o => [
        o.id,
        o.clientName || '',
        getOrderProductLabel(o),
        this.getEstadosNames(o.estados) || o.status || '',
        money(getOrderDeliveryPrice(o)),
        money(getOrderAmountPaid(o)),
        money(getOrderTotalAmount(o)),
        getBoletaExportLabel(o.id, boletas)
      ]);
      autoTable(doc, {
        startY: 35,
        head,
        body,
        theme: 'grid',
        headStyles: { fillColor: [0, 0, 0] },
        styles: { fontSize: 7 },
        columnStyles: { 2: { cellWidth: 42 }, 7: { cellWidth: 36 } }
      });
      const finalY = (doc as any).lastAutoTable.finalY + 10;
      doc.setFontSize(11);
      doc.setFont('helvetica', 'bold');
      doc.text(`Total cobrado (adelantos): ${money(kpis.totalAdelantado)}`, 14, finalY);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(10);
      doc.text(`Pendiente: ${money(kpis.totalPagoPendiente)}  |  Envío (informativo): ${money(kpis.totalEnvioAdelantado)}`, 14, finalY + 7);
      doc.save('ventas_manuales_activas.pdf');
    });
  }

  private runExport(
    kind: 'excel' | 'pdf',
    consume: (bundle: AdminExportBundle) => Promise<void> | void
  ): void {
    if (this.exporting) return;
    const filters = this.listFilters();
    const summary = kind === 'excel' ? 'Excel' : 'PDF';
    if (!filters) {
      this.messageService.add({ severity: 'warn', summary, detail: 'No hay pedidos para exportar' });
      return;
    }
    this.exporting = kind;
    this.cd.detectChanges();
    loadAdminExport(this.orderService, this.boletaService, filters).subscribe({
      next: (bundle) => {
        if (!bundle.rows.length) {
          this.exporting = null;
          this.messageService.add({ severity: 'warn', summary, detail: 'No hay pedidos para exportar' });
          this.cd.detectChanges();
          return;
        }
        Promise.resolve()
          .then(() => consume(bundle))
          .catch((e: Error) => this.messageService.add({
            severity: 'warn',
            summary,
            detail: e?.message || 'No se pudo exportar'
          }))
          .finally(() => {
            this.exporting = null;
            this.cd.detectChanges();
          });
      },
      error: () => {
        this.exporting = null;
        this.messageService.add({ severity: 'error', summary, detail: 'No se pudo exportar' });
        this.cd.detectChanges();
      }
    });
  }
}